import React from "react";

const PrivateRoomsMcGregorOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="340"
      height="1367"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 340 1367"
      xmlSpace="preserve"
      className='clickable'
    >
      <g transform="translate(-1429.5 -442.5)">
        <path
          fill="rgba(0,0,0,0)"
          className='object-glow'
          stroke="#ff5c97"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="5"
          d="M1432 1112l3-667 331 89 1 1105-329 168-5-449"
          opacity="1"
        ></path>
      </g>
    </svg>
  );
}

export default PrivateRoomsMcGregorOutline;